/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Alert,
  Col,
  Row,
  Card,
  Accordion,
  Button,
  Form,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { InssuredData } from "../../subPages/InsuredData/InssuredData";
import { HospitalData } from "../../subPages/HospitalData/HospitalData";
import { Documentation } from "../../subPages/Documentation/Documentation";
import { Binnacle } from "../../subPages/Binnacle/Binnacle";
import AuthLetters from "../../subPages/AuthLetter/AuthLetters";
import {
  getBySlug,
  update,
} from "../../services/hospitalizationcrud";
import { getLasMcMovementtByCase } from "../../services/mcMovementsService";
import { getLastLetterMovByCase } from "../../services/letterMovsService";
import { isEmpty } from "../../../_utils/checkObjectEmpty";
import moment from "moment";
import { ContentMedicAssignationTrakingMedic } from "../../subPages/MedicAssignationTracking/MedicAssignationTrackingMedic";
import { IfHasRole } from "../../../../_metronic/_helpers";
import { MedicalFees } from "../../subPages/MedicalFee/MedicalFees";
import { MedicAssigned } from "../../subPages/MedicAssigned/MedicAssigned";
import { FamilyData } from "../../subPages/FamilyData/FamilyData";
import { InsuranceData } from "../../subPages/InsuranceData/InsuranceData";
import { Opinion } from "../../subPages/Dictum/Dictum";
import CaseHeader from "../../subPages/CaseHeader/CaseHeader";
import BlockCaseContext from "../../../contexts/BlockCaseContext";
import $ from "jquery";

const TabDetails = (props) => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Tabulaciones");

  const { slug } = props.match.params;

  const [caseRecord, setCaseRecord] = useState({});
  const [mcMovement, setMcMovement] = useState({});
  const [letterMov, setLetterMov] = useState({});
  const [totalLetters, setTotalLetters] = useState(0);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);

  useEffect(() => {
    window.wasCommented = false;
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      getLasMcMovementtByCase(response.data.id).then((currentMcMovemet) =>
        setMcMovement(currentMcMovemet.data)
      );
      getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
        setLetterMov(currrentLetterMov.data)
      );
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  let history = useHistory();

  let submitFormCostControlData = null;
  let submitFormCostControlDataErrors = null;

  const bindSubmitFormCostControlData = (submitForm) =>
    (submitFormCostControlData = submitForm);

  const bindSubmitFormCostControlDataErrors = (errors) =>
    (submitFormCostControlDataErrors = errors);

  let submitFormMedicAssignation = null;
  let submitFormMedicAssignationErrors = null;

  const bindSubmitFormMedicAssignation = (submitForm) =>
    (submitFormMedicAssignation = submitForm);

  const bindSubmitFormMedicAssignationErrors = (errors) =>
    (submitFormMedicAssignationErrors = errors);

  const onClickSendDictum = async () => {
    await submitFormCostControlData();
    if (isEmpty(submitFormCostControlDataErrors)) {
      let inputReasonDictum = document.getElementById("reason_sendToDictum").value;
      if (inputReasonDictum === "") {
        alert("Debe seleccionar una razon");
        return;
      }
      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }
      $("#btn_save_comment").click();
      let timestamp = await axios.get('/cases/getTimestamp');
      update({ caseStatusId: 5, dictumReason: inputReasonDictum, feadictamen: moment.utc(timestamp.data).format()}, 
        caseRecord.id
        ).then((response) => {
        history.push("/control_costos");
      });
    }
  };

  const onClickPatientStore = async () => {
    await submitFormCostControlData();
    if (isEmpty(submitFormCostControlDataErrors)) {
      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }
      $("#btn_save_comment").click();
      let timestamp = await axios.get('/cases/getTimestamp');
      update(
        { caseStatusId: 7, feaapaciente: moment.utc(timestamp.data).format()}, 
        caseRecord.id
        ).then((response) => {
        history.push("/control_costos");
      });
    }
  };

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Tabulaciones
      </Alert>

      <CaseHeader
        caseRecord={caseRecord}
        hideComprehensiveCare={true}
        hideRequiresTabulation={true}
        hideHospitalModel={true}
        showFolioEp={true}
        showPolicy={true}
      />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
        <Accordion defaultActiveKey="8" className="mt-5">
          <HospitalData
            icon="fa-search"
            eventKey="0"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={()=>{}}
          />
          <InssuredData
            icon="fa-search"
            eventKey="1"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={()=>{}}
          />
          <FamilyData
            icon="fa-search"
            eventKey="2"
            data={caseRecord}
            disabledAll={true}
            {...props}
            bindSubmitForm={()=>{}}
          />
          <MedicAssigned
            icon="fa-search"
            eventKey="3"
            data={caseRecord}
            bindSubmitForm={()=>{}}
          />
          <InsuranceData
            icon="fa-search"
            eventKey="4"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={()=>{}}
          />
          <Opinion
            icon="fa-search"
            eventKey="5"
            data={caseRecord}
            disabledAll={true}
            totalLetters={totalLetters}
            bindSubmitForm={() => {}}
          />
          <AuthLetters
            icon="fa-search"
            showForm={false}
            hideDeleteOption={true}
            eventKey="6"
            data={caseRecord}
            disabledAll={false}
            setTotalLetters={setTotalLetters}
            {...props}
          />
          <Documentation
            icon ="fa-search"
            eventKey="7"
            data={caseRecord}
            disabledAll={false}
            allowSelectiveDownload={true}
            {...props}
          />
          <MedicalFees
            icon= "fa-search"
            icone="fa-pencil-alt"
            eventKey="8"
            data={caseRecord}
            hideBtnInsurance={false}
            hideFormCreate={true}
            showForm={true}
            hideTabsModuleInputs={false}
            {...props}
          />
        </Accordion>
        <Accordion defaultActiveKey="0" className="mt-5">
          <Binnacle
            icon="fa-pencil-alt"
            eventKey="0"
            data={caseRecord}
            disabledAll={false}
            eventStage="Tabulaciones"
            {...props}
          />
        </Accordion>
      </BlockCaseContext.Provider>
    </>
  );
};

export default TabDetails;
